<template>
	<div id="MAM_terminalList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
            </div>
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="formInline.phone" placeholder="请输入登录账号"></el-input>
				</el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="formInline.terminal_sn" placeholder="请输入SN"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="达标开始日期"
                        end-placeholder="达标结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(formInline)">查询</el-button>
					<el-button size="medium" type="primary"  style="font-size: 12px;" @click="refreshClick()">手动刷新</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom: 10px;">
				<div class="tableTitle">
					<span class="st-label">活跃总台数：</span>
					<span
						class="st-word-aux">{{mainItem.lively_terminal_count}}台</span>
                    <span class="st-label" style="margin-left: 30px;">绑定总台数：</span>
                    <span
                    	class="st-word-aux">{{mainItem.bind_terminal_count}}台</span>
                    <span class="st-label" style="margin-left: 30px;">活跃率：</span>
                    <span
                    	class="st-word-aux">{{mainItem.lively_ratio}}%</span>
				</div>
			</div>
			<el-table :data="transferList.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column header-align="center" align="center" prop="phone" label="登录账号"
					min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="channel_mer_no" label="商户编号"
					min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="terminal_sn" label="SN" min-width="180"></el-table-column>
                <el-table-column header-align="center" align="center" prop="terminal_type_text" label="进件渠道" min-width="160">
                </el-table-column>
				<el-table-column header-align="center" align="center" prop="bind_time" label="绑机时间" min-width="160"></el-table-column>
                <el-table-column header-align="center" align="center" prop="active_time" label="激活时间" min-width="160"></el-table-column>
                <el-table-column header-align="center" align="center" prop="month_lively_time" label="活跃达标时间" min-width="160"></el-table-column>
				<el-table-column header-align="center" align="center" prop="transaction_money" label="交易金额(元)" min-width="150">
				</el-table-column>
                <el-table-column header-align="center" align="center" prop="transaction_number" label="交易订单号" min-width="160">
                </el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize" style="text-align: center"></paginations>
		</el-card>
        
	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "downSalaryAwardFinishList",
		data() {
			return {
				brandList: [],
				formInline: {
					date:this.$route.query.date,
					user_id:this.$route.query.user_id,
                    record_id:this.$route.query.record_id,
                    phone:'',
                    terminal_sn:'',
                    group_name:'',
                    level_name:''
				},
				transferList: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				loading: true,
                mainItem:{},
                rangeDate:[],
			}
		},
		mounted() {
			this.getData()
		},
		components: {
			paginations,
		},
		methods: {
            pickerChange(DateArr) { //时间选择器
                this.formInline.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.formInline.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");

            },
            refreshClick(){
                this.loading = true;
                this.$api.post("user_dividends/refreshSalaryTerminalRecord", {date:this.$route.query.date}, res => {
                    this.loading = false;
                    this.page.currentPage = 1;
                    // 表单提交
                    this.getData()
                	
                })
            },
  
			onSearch() { //搜索
				this.page.currentPage = 1;
				// 表单提交
				this.getData()
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.getData();
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.getData()
			},
			getData() {
                this.formInline.page = this.page.currentPage
                this.formInline.limit = this.page.pageSize
				this.$api.post("user_dividends/salaryTerminalRecordList", this.formInline, res => {
					let data = res.data;
					this.page.total = data.list.total; //总数
					this.transferList.list = res.data.list.data;
                    this.mainItem = data
					//渲染结束后取消加载
					this.loading = false;
				})
			}
			
		}
	};
</script>





<style lang="scss" scope>
	.el-input__inner {
		font-size: 12px;
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.el-date-editor .el-range-input,
	.el-date-editor .el-range-separator {
		font-size: 12px;
	}

	.el-popover__title {
		font-size: 12px;
		font-weight: 700;
	}

	.MAM_terminalList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}

		.tableTitle {
			display: inline-block;
			margin-right: 20px;
		}
	}

	.terminal_operate {
		display: flex;
	}

	.el-button {
		font-size: 12px !important;
	}
</style>